/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { alertActions } from '../../../_actions/alert.actions';
import { vaccineScheduleService } from '../../../_services/vaccine-schedule.service';
import PendingActions from './PendingActions';
import ReassignModal from './ReassignModal';
import CloseModal from './CloseModal';
import ExportAction from './ExportAction';

export default function ListTimeSlots() {
  const columns = [
    {
      name: 'Time Slot',
      sort: false,
      cell: row => moment.tz(row.timeSlot.date, row.timeSlot.timezone).local().format('l LT')

    },
    {
      name: 'Status',
      sort: false,
      cell: row => {
        if (row.status === 'open') {
          return <span className="badge bg-primary text-white">OPEN</span>
        } else if (row.status === 'pending') {
          return <span className="badge bg-info text-white">PENDING</span>
        } else if (row.status === 'scheduled') {
          return <span className="badge bg-success text-white">SCHEDULED</span>
        } else if (row.status === 'rejected') {
          return <span className="badge bg-warning">REJECTED</span>
        }
      }
    },
    {
      name: 'First Name',
      sort: false,
      cell: row => {
        if (row.reservation) {
          return row.reservation.firstName
        }
      }
    },
    {
      name: 'Last Name',
      sort: false,
      cell: row => {
        if (row.reservation) {
          return row.reservation.lastName
        }
      }
    },
    {
      name: 'Phone Number',
      sort: false,
      cell: row => {
        if (row.reservation) {
          return row.reservation.phoneNumber
        }
      }
    },
    {
      name: 'Allow SMS',
      sort: false,
      cell: row => {
        if (row.reservation) {
          return row.reservation.allowSms ? <span className="badge bg-success text-white">YES</span> : <span className="badge bg-warning">NO</span>
        }
      }
    },
    {
      name: 'Appt. Sent At',
      sort: false,
      cell: row => {
        if (row.sentAt) {
          return moment.tz(row.sentAt.date, row.sentAt.timezone).local().format('l LT')
        }
      }
    },
    {
      button: true,
      width: '200px',
      sort: false,
      cell: row => {
        if (row.status === 'pending') {
          return <PendingActions data={row} reload={() => { retrieve(page) }} />
        }
      }
    }
  ];
  const { scheduleId } = useParams();

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [reservations, setReservations] = useState([]);

  function retrieve(page = 1) {
    vaccineScheduleService.slots(scheduleId, page)
      .then(data => {
        setLoading(false);

        setTotalRows(data.total);
        setReservations(data.collection.data);
      })
      .catch(() => {
        setLoading(false);

        dispatch(alertActions.error('Could not retrieve schedule slots. Please try again.'));
      });
  }

  useEffect(() => {
    retrieve();
  }, []);

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/vaccine/schedule">Schedules</Link></li>
        <li className="breadcrumb-item active" aria-current="page">Time Slots</li>
      </ol>
    </nav>

    <div className="row mb-3">
      <div className="col-1">
        <ExportAction scheduleId={scheduleId} />
      </div>
      <div className="col-1">
        <ReassignModal scheduleId={scheduleId} />
      </div>
      <div className="col-2 offset-1">
        <CloseModal scheduleId={scheduleId} />
      </div>
    </div>

    <DataTable
      columns={columns}
      data={reservations}
      progressPending={loading}
      onChangePage={page => {
        setLoading(true);
        retrieve(page);
        setPage(page);
      }}
      striped={true}
      pagination={true}
      paginationServer={true}
      paginationTotalRows={totalRows}
      paginationRowsPerPageOptions={[15]}
      paginationPerPage={15}
      customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
    />
  </div>
}